import React from 'react';
import { Router } from 'react-router';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';

import { setLanguage } from '@eventbrite/i18n';
import { getHistory, updateHistory } from '@eventbrite/react-router-history';
import { middleware as gaMiddleware } from '@eventbrite/site-analytics';
import {
    ENV_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    USER_SHAPE_PROP_TYPE,
    FOOTER_LINKS_SHAPE_PROP_TYPE,
} from '@eventbrite/site-structure';
import { configureStore } from '@eventbrite/redux-configure-store';

import { GA_DEFAULT_CATEGORY } from './constants';
import reducer from './reducers';
import getRoutes from './routes';
import { getInitialState } from './selectors/get-initial-state';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eventbrite/site-analytics';

export default class Covid19App extends React.Component {
    static propTypes = {
        env: ENV_SHAPE_PROP_TYPE.isRequired,
        request: REQUEST_SHAPE_PROP_TYPE.isRequired,
        user: USER_SHAPE_PROP_TYPE.isRequired,
        footerLinks: FOOTER_LINKS_SHAPE_PROP_TYPE.isRequired,
    };

    constructor(props) {
        super(props);

        setLanguage(this.props.env.localeInfo.locale);

        // create a history object depending on the environment
        // server-side: dummy/memory history
        // client-side: browser history
        this._history = getHistory();

        // creates a store w/ Redux logging defaulted in development environment
        // also adds `redux-thunk` middleware by default for async actions
        this._store = configureStore({
            reducer,
            initialState: getInitialState(props),
            middleware: [
                thunk,
                routerMiddleware(this._history),
                gaMiddleware(this.props, () => ({
                    category: GA_DEFAULT_CATEGORY,
                })),
            ],
        });

        // make the store the source of truth for the current route we're on
        this._history = syncHistoryWithStore(this._history, this._store);

        // sync the server-side request information w/ the history to make sure
        // we render the correct initial route
        updateHistory(this._history, props.request);
    }

    componentDidMount() {
        initDimensionsFromState(this.props);
        trackInitialPageView(this.props.gaSettings);
    }

    UNSAFE_componentWillReceiveProps({ request }) {
        // any time we update the App's props after initial render (which really should be never)
        // make sure we also update the history with any changes in the request
        updateHistory(this._history, request);
    }

    render() {
        const routes = getRoutes(this.props);

        return (
            <Provider store={this._store}>
                <Router history={this._history} routes={routes} />
            </Provider>
        );
    }
}
